/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireResultDimensionRisk } from './CustomQuestionnaireResultDimensionRisk';
import {
  CustomQuestionnaireResultDimensionRiskFromJSON,
  CustomQuestionnaireResultDimensionRiskFromJSONTyped,
  CustomQuestionnaireResultDimensionRiskToJSON,
} from './CustomQuestionnaireResultDimensionRisk';
import type { ResidualRiskLabel } from './ResidualRiskLabel';
import {
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelFromJSONTyped,
  ResidualRiskLabelToJSON,
} from './ResidualRiskLabel';
import type { Risk } from './Risk';
import { RiskFromJSON, RiskFromJSONTyped, RiskToJSON } from './Risk';

/**
 *
 * @export
 * @interface CustomQuestionnaireResultResidualRisk
 */
export interface CustomQuestionnaireResultResidualRisk {
  /**
   *
   * @type {Risk}
   * @memberof CustomQuestionnaireResultResidualRisk
   */
  readonly risk: Risk;
  /**
   *
   * @type {Array<CustomQuestionnaireResultDimensionRisk>}
   * @memberof CustomQuestionnaireResultResidualRisk
   */
  readonly dimensionLabels: Array<CustomQuestionnaireResultDimensionRisk>;
  /**
   *
   * @type {ResidualRiskLabel}
   * @memberof CustomQuestionnaireResultResidualRisk
   */
  readonly riskLabel: ResidualRiskLabel | null;
}

/**
 * Check if a given object implements the CustomQuestionnaireResultResidualRisk interface.
 */
export function instanceOfCustomQuestionnaireResultResidualRisk(
  value: object,
): value is CustomQuestionnaireResultResidualRisk {
  if (!('risk' in value) || value['risk'] === undefined) return false;
  if (!('dimensionLabels' in value) || value['dimensionLabels'] === undefined) return false;
  if (!('riskLabel' in value) || value['riskLabel'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireResultResidualRiskFromJSON(json: any): CustomQuestionnaireResultResidualRisk {
  return CustomQuestionnaireResultResidualRiskFromJSONTyped(json, false);
}

export function CustomQuestionnaireResultResidualRiskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireResultResidualRisk {
  if (json == null) {
    return json;
  }
  return {
    risk: RiskFromJSON(json['risk']),
    dimensionLabels: (json['dimension_labels'] as Array<any>).map(CustomQuestionnaireResultDimensionRiskFromJSON),
    riskLabel: ResidualRiskLabelFromJSON(json['risk_label']),
  };
}

export function CustomQuestionnaireResultResidualRiskToJSON(
  value?: Omit<CustomQuestionnaireResultResidualRisk, 'risk' | 'dimensionLabels' | 'riskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
